import { FunctionComponent } from 'react';
import { BodyText, Gutter, Panel, Price, Title } from '@gaiads/telia-react-component-library';
import { AllowanceType } from '@cdaas/api-clients/dist/asset-user-openapi';
import { useTranslation } from 'react-i18next';

import { User } from '../../../../types';
import { isNumeric } from '../../../../utils';

const Allowance: FunctionComponent<{
  user: User;
}> = ({ user }) => {
  const { t } = useTranslation('product');
  return (
    <Panel
      margin={{
        bottom: 'xlg',
      }}
      padding={{
        size: 'lg',
      }}
    >
      <Title size="sm">{t('allowance.ingress')}</Title>
      {isNumeric(user.allowance) && (
        <Price
          value={Number(user.allowance)}
          description={t('allowance.includingVat')}
          unit={user.organization?.locale.currency.toUpperCase()}
          unitSpecifier={user.allowance_type === AllowanceType.Monthly ? t('allowance.month') : undefined}
          size="lg"
        />
      )}
      <Gutter size="sm" />
      <BodyText>{t('allowance.paragraph1')}</BodyText>
      <Gutter size="sm" />
      <BodyText>{t('allowance.paragraph2')}</BodyText>
    </Panel>
  );
};

export default Allowance;
